import { useEffect } from "react";
import { pos } from "@/platform";
import { useAuthUser } from "@/context/auth/AuthContext";
import { FOTO_INICIAL, useFotoDeLaCaja } from "@/context/caja/fotoDeLaCaja";

/**
 * Sigue la foto de la caja del negocio de la sesión (#345 AC-7) y el estado
 * del almacén (AC-9). Sólo en el escritorio: la web no tiene foto (D5).
 */
export function useSeguirLaFotoDeLaCaja() {
  const businessId = useAuthUser()?.businessId as string | undefined;

  useEffect(() => {
    if (!pos.isAvailable) return;
    let vigente = true;
    void pos
      .storeStatus()
      .then((almacen) => vigente && useFotoDeLaCaja.setState({ almacen }))
      .catch(() => {});
    if (!businessId) {
      useFotoDeLaCaja.setState({ foto: FOTO_INICIAL });
      return () => {
        vigente = false;
      };
    }
    void pos
      .photoStatus(businessId)
      .then((foto) => vigente && useFotoDeLaCaja.setState({ foto }))
      .catch(() => {});
    const dejar = pos.onPhoto((foto) => {
      // Al cambiar de negocio puede llegar el último aviso de la caja anterior:
      // su `lista` no es la de éste (#360).
      if (vigente && (!foto.businessId || foto.businessId === businessId)) {
        useFotoDeLaCaja.setState({ foto });
      }
    });
    return () => {
      vigente = false;
      void dejar.then((f) => f());
    };
  }, [businessId]);
}
